/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {browserHistory} from 'react-router';
import * as FormName from '../../../constants/formNameConstants';
import * as caseDataActions from '../../../actions/caseDataActions.js';
import * as pathConstants from '../../../constants/pathConstants';
import {
  searchForFormById,
  searchForCaseData
} from '../../../selectors/searchForForm';
import {searchForEstablishmentById} from '../../../selectors/searchForEstablishment';
import confirmFormIsValid from './CaseDataEditChecks';
import CaseDataForm from './CaseDataForm';
import {createcaseDataDataObject} from '../caseDataModel';
import * as caseDataConstants from '../../../constants/caseDataConstants';
import '../../../styles/caseData/caseData.css';
import {ITAAlert} from '../../common/ITAAlert';
import * as PathConstants from '../../../constants/pathConstants';

export class CaseDataPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      caseData: Object.assign({}, this.props.caseData),
      formIsValid: this.props.params.caseDataFormId ? true : false,
      activeFields: [],
      errors: {},
      softErrors: {},
      caseDatas: props.caseDatas,
    };

    this.submitCaseData = this.submitCaseData.bind(this);
    this.enteringData = this.enteringData.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.cancelCaseData = this.cancelCaseData.bind(this);
    this.setActiveFields = this.setActiveFields.bind(this);
    this.redirect = this.redirect.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.goBackToHomePage = this.goBackToHomePage.bind(this);
  }

  componentDidMount() {

    if(this.props.caseDataLinks.length > 0){
      let linkFound = false;

      let caseData = this.props.caseData;
      this.props.caseDataLinks.forEach(caseDataLink=>{
        let lastCharUrl = caseDataLink.lastIndexOf('/') + 1;
        let caseDataLinkId = caseDataLink.slice(lastCharUrl);
        if(caseDataLinkId == caseData.id){
          linkFound = true;
        }
      });

      if(linkFound === false && this.props.caseData.id){
        browserHistory.push(pathConstants.pathToAccessDenied);
      }
    }
  }

  goBackToHomePage() {
    console.log('Return user to home page');
    this.redirect(PathConstants.pathToHome);
  }

  componentWillReceiveProps(nextProps) {

     if(nextProps.caseDataLinks[0] != this.props.caseDataLinks[0]){
        let caseData = nextProps.caseData;
        let caseDataLink = nextProps.caseDataLinks[0];
        let lastCharUrl = caseDataLink.lastIndexOf('/') + 1;
        let caseDataLinkId = caseDataLink.slice(lastCharUrl);

        if(caseDataLinkId != caseData.id){
          browserHistory.push(pathConstants.pathToAccessDenied);
        }
     }

     if(this.props.establishments.length > 0 && !nextProps.establishment){
       browserHistory.push(pathConstants.pathToAccessDenied);
     }

     if(nextProps.establishment && nextProps.establishment.establishment_status==2){
       browserHistory.push(pathConstants.pathToPageNotFound);
     }

     if (this.props.caseData.id !== nextProps.caseData.id) {
       // Necessary to populate form when existing course is loaded directly.
       this.setState({caseData: Object.assign({}, nextProps.caseData)});
     }
     if (this.state.caseDatas.length == 0) {
      this.setState({
        caseDatas: nextProps.caseDatas
      });
    }
  }

  enteringData(event) {
    event.preventDefault();
    const field = event.target.name;
    let caseData = this.state.caseData;
    caseData[field] = event.target.value;
    this.setActiveFields(field);
    this.setState({caseData: caseData});
    this.setState({formIsValid: confirmFormIsValid(this.props.caseDataForm, this.state.caseData, this.props.requiredFields, this.state.activeFields, this.state.caseDatas).formIsValid});
    this.setState({errors: confirmFormIsValid(this.props.caseDataForm, this.state.caseData, this.props.requiredFields, this.state.activeFields, this.state.caseDatas).errors});
    this.setState({softErrors: confirmFormIsValid(this.props.caseDataForm, this.state.caseData, this.props.requiredFields, this.state.activeFields, this.state.caseDatas).softErrors});
  }

  handleClick(event) {
    const field = event.target.name;
    const currentDate = new Date();
    let caseData = this.state.caseData;
    if (field == 'dateOfBirth') {
      // convert to age.
      const dateofBirth = new Date(event.target.value);
      const dateOfIncident = new Date(caseData.date_of_incident);
      const yearDiff = dateOfIncident.getFullYear() - dateofBirth.getFullYear();
      caseData[field] = yearDiff;
      caseData['age'] = yearDiff;
    }
    else if (field == 'hiredDate') {
      // Convert to length.
      const hiredDate = new Date(event.target.value);
      caseData['hiredDate'] = new Date(event.target.value);
      const currentDate = new Date();
      const yearDiff = currentDate.getFullYear() - hiredDate.getFullYear();
      const monthDiff = (yearDiff * 12) + currentDate.getMonth() - hiredDate.getMonth();
      if (monthDiff < 3) {
        caseData['lengthOfService'] = 0;
      }
      else if (monthDiff >= 3 && monthDiff <=11) {
        caseData['lengthOfService'] = 1;
      }
      else if (monthDiff >= 12 && monthDiff <=60) {
        caseData['lengthOfService'] = 2;
      }
      else {
        caseData['lengthOfService'] = 3;
      }
    }
    // Set the time fields to 00:00 if it gets focus and it is empty.
    else if (field == 'timeEmployeeBegan' || field == 'timeOfEvent' ) {
      if (event.target.value == '') {
        caseData[field] = '00:00';
      }
      // If an actual time is entered uncheck the time_unknown field.
      if (field == 'timeOfEvent') {
        caseData['timeUknown'] = caseDataConstants.TIME_KNOWN;
      }
    }
    // When time unknown is toggled, clear the time of event field
    // or reset it to 12:00 if it is empty appropriately.
    else if (field == 'timeUknown') {
      // When checkbox is checked, clear time of event.
      if (event.target.checked) {
        caseData['timeUknown'] = caseDataConstants.TIME_UNKNOWN;
        caseData['timeOfEvent'] = '';
      }
      // When the checkbox is unchecked, if the time is empty, set it to 00:00
      else {
        caseData['timeUknown'] = caseDataConstants.TIME_KNOWN;
        caseData['timeOfEvent'] = '00:00';
      }
    }
    // Allow date of death only when the most serious outcome is death.
    // If it is not, then reset the date of death field.
    else if (field == 'mostSeriousOutcome') {
      if (event.target.value != caseDataConstants.MOST_SERIOUS_OUTCOME_DEATH) {
        caseData['dateOfDeath'] = '';
      }

      // If most serious outcome is awayFromWork then
      // set awayFromWork to 0.
      if (event.target.value == caseDataConstants.DAYS_AWAY_FROM_WORK) {
        caseData['awayFromWork'] = '';
        caseData['jobTransferRestriction'] = '';
      }

      // If most serious outcome is jobTransferRestriction then
      // set jobTransferRestriction to 0.
      if (event.target.value == caseDataConstants.JOB_TRANSFER_OR_RESTRICTION) {
        caseData['jobTransferRestriction'] = '';
        caseData['awayFromWork'] = '0';
      }

      // If most serious outcome is other recordable case or death,
      // then disable data entry for question awayFromWork and jobTransferRestriction.
      if (event.target.value == caseDataConstants.OTHER_RECORDABLE_CASES ||
        event.target.value == caseDataConstants.MOST_SERIOUS_OUTCOME_DEATH) {
        caseData['awayFromWork'] = '0';
        caseData['jobTransferRestriction'] = '0';
      }

      caseData[field] = event.target.value;
    }
    else {
      caseData[field] = event.target.value;
    }

    this.setState({caseData: caseData});
    this.setState({formIsValid: confirmFormIsValid(this.props.caseDataForm, this.state.caseData, this.props.requiredFields, this.state.activeFields, this.state.caseDatas).formIsValid});
    this.setState({errors: confirmFormIsValid(this.props.caseDataForm, this.state.caseData, this.props.requiredFields, this.state.activeFields, this.state.caseDatas).errors});
    this.setState({softErrors: confirmFormIsValid(this.props.caseDataForm, this.state.caseData, this.props.requiredFields, this.state.activeFields, this.state.caseDatas).softErrors});
  }

  onBlur(event) {
    event.preventDefault();
    const field = event.target.name;
    // Add condition during adding data to the form.
    this.setActiveFields(field);
    this.setState({formIsValid: confirmFormIsValid(this.props.caseDataForm, this.state.caseData, this.props.requiredFields, this.state.activeFields, this.state.caseDatas).formIsValid});
    this.setState({errors: confirmFormIsValid(this.props.caseDataForm, this.state.caseData, this.props.requiredFields, this.state.activeFields, this.state.caseDatas).errors});
    this.setState({softErrors: confirmFormIsValid(this.props.caseDataForm, this.state.caseData, this.props.requiredFields, this.state.activeFields, this.state.caseDatas).softErrors});
  }

  setActiveFields(field) {
    let activeFields = this.state.activeFields;
    if (activeFields.indexOf(field) == -1) {
      activeFields.push(field);
      this.setState({activeFields: activeFields});
    }
  }

  submitCaseData(event) {
    event.preventDefault();
    let date = new Date();
    let message = (<ITAAlert
      style="success"
      message={<div> <div className="first-line">
      On {date.toLocaleDateString()}
      {} at {date.toLocaleTimeString()}, you have successfully added a case data.
    </div> </div>}/>);
    const establishment = this.props.establishment;
    this.setState({formIsValid: false});
    this.props.actions.submitCaseDataSummary(
      establishment,
      this.state.caseData,
      this.props.caseDataId)
      .then((establishmentId) => {
        this.setState({
          message: message
        });
        this.redirect(establishmentId);
      }).catch(error => {
      this.setState({formIsValid: true});
      throw(error);
    });
  }

  cancelCaseData(event) {
    event.preventDefault();
    browserHistory.push(pathConstants.pathToEstablishmentsDashboardPage + '/' +  this.props.establishment.id + pathConstants.pathToCaseDataDashboardPage);
  }

  redirect(id) {
    if (id != null) {
      if(this.props.caseDataId){
        browserHistory.push({
          pathname: pathConstants.pathToEstablishmentsDashboardPage + '/' +  id + pathConstants.pathToCaseDataDashboardPage,
          state: {
            message: "CaseData",
            newCase: false
          }
        });
      } else{
        browserHistory.push({
          pathname: pathConstants.pathToEstablishmentsDashboardPage + '/' +  id + pathConstants.pathToCaseDataDashboardPage,
          state: {
            message: "CaseData",
            newCase: true
          }
        });
      }
    }
    else {
      browserHistory.push({
        pathname: pathConstants.pathToEstablishmentsDashboardPage,
        state: {
          message: "CaseData",
          newCase: true
        }
      });
    }
  }

  render() {
    return (
      <div>
        {this.state.message}
        {this.props.user && <CaseDataForm
          form={this.props.caseDataForm}
          onChange={this.enteringData}
          establishment={this.props.establishment}
          onClick={this.handleClick}
          onSubmit={this.submitCaseData}
          onCancel={this.cancelCaseData}
          caseData={this.state.caseData}
          submitStatus={this.state.formIsValid}
          onBlur={this.onBlur}
          errors={this.state.errors}
          softErrors={this.state.softErrors}
        />}
      </div>
    );
  }
}

CaseDataPage.propTypes = {
  actions: PropTypes.object.isRequired,
  establishment: PropTypes.object,
  establishments: PropTypes.array,
  caseDataId: PropTypes.string,
  caseData: PropTypes.object.isRequired,
  caseDataLinks: PropTypes.array.isRequired,
  caseDataForm: PropTypes.object.isRequired,
  requiredFields: PropTypes.array,
  user: PropTypes.object,
  caseDatas: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  const establishmentId = ownProps.params.establishmentId;
  const establishments = state.establishments;
  const establishment = searchForEstablishmentById(establishments, establishmentId);
  const caseDataFormId = ownProps.params.caseDataFormId;
  let requiredFields = [];
  let caseDatas = state.caseDatas;
  let caseData = {
    caseNumber: '',
    jobTitle: '',
    dateOfIncident: '',
    timeOfIncident: '',
    incidentLocation: '',
    incidentOutcome: '',
    dateOfDeath: '',
    dafw: '',
    djtr: '',
    dateOfBirth: '',
    employeeHiredDate: '',
    hiredDate: '',
    employeeGender: '',
    treatmentType: '',
    treatmentPatient: '',
    timeStartedWork: '',
    timeUknown: '',
    narBeforeIncident: '',
    narWhatHappened: '',
    narInjuryIlness: '',
    narObjectSubstance: '',
    id: caseDataFormId,
    establishment:{ id: establishmentId},
  };
  let caseDataForm = {};
  let caseDataLinks = [];
  if (establishment && establishment.links && establishment.links.case_data_links) {
    establishment.links.case_data_links.forEach(link => {
      caseDataLinks.push(link);
    });
  }
  if (state.forms.length > 0) {
    caseDataForm =
      searchForFormById(state.forms, FormName.itaCaseDataFormId);
  }
  let retrievedCaseData = searchForCaseData(state.caseDatas, caseDataFormId);
  if (retrievedCaseData) {
    caseData = createcaseDataDataObject(retrievedCaseData);
    caseData.id = retrievedCaseData.id;
    caseData.establishment = {id: establishmentId};
  }

  if (caseDataForm && caseDataForm.formQuestions) {
    requiredFields = []
    .concat
    .apply([], caseDataForm.formQuestions.map(question => {
      return question
      .questionParts
      .map(questionPart => {
        if (questionPart.questionPartRequired == '1') {
          return questionPart;
        }
      })
      .filter(questionPart => {
        return questionPart;
      });
    }));
  }

  return {
    establishment: establishment,
    establishments: establishments,
    caseDataId: caseDataFormId,
    caseData: caseData,
    caseDataLinks: caseDataLinks,
    caseDataForm: caseDataForm,
    requiredFields,
    user: state.user[state.user.length - 1],
    caseDatas: caseDatas
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(caseDataActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseDataPage);



/** WEBPACK FOOTER **
 ** ./src/components/caseData/CaseDataManagement/CaseDataPage.js
 **/